import apiClient  from './api';

/**
 * Pricing API für Admin-Bereich und öffentliche Preisabfragen
 */


export const pricingApi = {

  async getCoinPricingRules() {
    const response = await apiClient.get('/pricing/coin-rules');
    return response.data || response;
  },


  async getTeamPlanPricing() {
    const response = await apiClient.get('/pricing/team-plans');
    return response.data || response;
  },


  async getTeamPlanFeatures() {
    const response = await apiClient.get('/pricing/team-features');
    return response.data || response;
  }
};


export const adminPricingApi = {

  async getAllPricingRules(params = {}) {
    const response = await apiClient.get('/admin/pricing/rules', { params });
    return response.data || response;
  },


  async getPricingRuleById(id) {
    const response = await apiClient.get(`/admin/pricing/rules/${id}`);
    return response.data || response;
  },


  async createPricingRule(ruleData) {
    const response = await apiClient.post('/admin/pricing/rules', ruleData);
    return response.data || response;
  },


  async updatePricingRule(id, ruleData) {
    const response = await apiClient.put(`/admin/pricing/rules/${id}`, ruleData);
    return response.data || response;
  },


  async deletePricingRule(id) {
    const response = await apiClient.delete(`/admin/pricing/rules/${id}`);
    return response.data || response;
  }
}; 